import { Button } from "@/design-system/components/ui";

/**
 * Server-side pagination footer for list pages (Leads, Brokers). The host
 * page owns the page state and the data query; this only renders the
 * "Showing X–Y of N" summary and the Previous / Next controls.
 */
export function Pagination({
  page, pageSize, totalCount, totalPages, onPrev, onNext,
}: {
  page: number;
  pageSize: number;
  totalCount: number;
  totalPages: number;
  onPrev: () => void;
  onNext: () => void;
}) {
  const from = (page - 1) * pageSize + 1;
  const to = Math.min(page * pageSize, totalCount);
  return (
    <div className="flex items-center justify-between mt-space-3">
      <span className="text-label text-gray-mid">
        Showing {from}–{to} of {totalCount} · Page {page} of {totalPages}
      </span>
      <div className="flex gap-space-2">
        <Button
          variant="secondary"
          size="sm"
          type="button"
          disabled={page <= 1}
          onClick={onPrev}
        >
          Previous
        </Button>
        <Button
          variant="secondary"
          size="sm"
          type="button"
          disabled={page >= totalPages}
          onClick={onNext}
        >
          Next
        </Button>
      </div>
    </div>
  );
}
